import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Wednesday, August 14, 2019`}</h1>
    <ul>
      <li parentName="ul">{`Built `}<a parentName="li" {...{
          "href": "https://hackpenn.com"
        }}>{`Hack Pennsylvania recap site`}</a><ul parentName="li">
          <li parentName="ul">{`Made this entirely on Glitch, which was a new experience for a full JS site. Great experience now that I've got the `}<inlineCode parentName="li">{`watch.json`}</inlineCode>{` files sorted out.`}</li>
        </ul></li>
      <li parentName="ul">{`Organized my Glitch profile, made some Collections for Hack Happy Valley, Hack Penn, my Hack Club, etc. I love Glitch.`}</li>
      <li parentName="ul">{`Got my Ruined by Design zine`}</li>
    </ul>
    <h2>{`Theme UI`}</h2>
    <p>{`After making the Hack Penn recap site, I feel like `}<strong parentName="p">{`I finally understand Theme UI & MDX now`}</strong>{`.
It's an incredible DX, where I don't feel like I'm writing the same boilerplate code
over & over like I do with styled-components/DS/my previous stack. You can't go back.`}</p>
    <p>{`I `}<em parentName="p">{`love`}</em>{` how with MDX, your content is separated from your code. Makes it so much more approachable, too.`}</p>
    <p>{`One interesting thing is the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` object for styling props.
Initially it looks like a downgrade—why not use first-class props like in DS?
(Historical note: this is actually a switch `}<em parentName="p">{`back`}</em>{` to how Rebass v0 did it with inline styles!
I was in 8th/9th grade when that happened.)
But once you're using it, the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` object prop is so much better. The syntax is easier to type & format
than JSX props, & mostly, it gives you an escape hatch. Need to do a weird selector or psuedoelement or
make a little change to a tag inside? You don't need to graduate to a full-on styled-component at the
top of the file with two lines of code in it, & do the awkward balancing act between `}<inlineCode parentName="p">{`attrs`}</inlineCode>{`,
`}<inlineCode parentName="p">{`defaultProps`}</inlineCode>{`, & JSX props, you can just open up `}<inlineCode parentName="p">{`sx={{ }}`}</inlineCode>{` & make the change right there. `}<strong parentName="p">{`It encourages
a much healthier balance of components`}</strong>{`—you can easily recognize when a component is getting unweildy in
your MDX & move it over to a JS file to be resuable.`}</p>
    <p>{`Before Theme UI, I was feeling kinda done building Gatsby + DS sites. I've made like a dozen, & maintained
hackclub.com, 2019.hackpenn.com, hackhappyvalley.com, statehigh.hackclub.com, & so many others. It's not a
bad library, but I was getting tired of a lot of little patterns I didn't love.`}</p>
    <p>{`With MDX & Next.js/Gatsby & Theme UI, I've got something new, & `}<strong parentName="p">{`it feels distinctly better`}</strong>{`. It's going to be
awhile before this catches on, if it ever becoems at all popular, but in the meantime, like `}<a parentName="p" {...{
        "href": "https://twitter.com/lachlanjc/status/1160979484637618177?s=20"
      }}>{`I said about
Next.js`}</a>{`, it makes me want to build things.
That's when you know you've got a really incredible stack.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      